import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Avatar, CreatorName, formatNum, VScore } from "./common";
import { TrendingUp, Radio, Rocket } from "lucide-react";
import { Button } from "./ui/button";

export function RightRail() {
  const [rising, setRising] = useState([]);
  const [live, setLive] = useState([]);
  const [chart, setChart] = useState([]);

  useEffect(() => {
    api.get("/rising-stars").then(({ data }) => setRising(data.slice(0, 5))).catch(() => {});
    api.get("/live").then(({ data }) => setLive(data.slice(0, 4))).catch(() => {});
    api.get("/charts?category=Top Artists").then(({ data }) => setChart(data.entries.slice(0, 5))).catch(() => {});
  }, []);

  return (
    <aside className="hidden xl:block w-80 shrink-0 p-5 space-y-5 sticky top-16 self-start h-[calc(100vh-4rem)] overflow-y-auto hide-scroll">
      <div className="surface rounded-2xl p-4">
        <div className="flex items-center gap-2 mb-3"><TrendingUp size={16} className="text-eblue" /><h3 className="font-display font-semibold text-sm">VCharts · Top Artists</h3></div>
        <div className="space-y-3">
          {chart.map((row, i) => (
            <Link key={i} to={`/${row.entity.username}`} className="flex items-center gap-3 group">
              <span className="font-mono text-gold text-sm w-4">{i + 1}</span>
              <Avatar src={row.entity.avatar_url} name={row.entity.display_name} size={32} />
              <div className="min-w-0 flex-1"><div className="text-sm font-medium truncate group-hover:text-eblue transition-colors"><CreatorName user={row.entity} /></div><div className="text-xs text-muted-foreground">VStar <VScore value={row.score} /></div></div>
            </Link>
          ))}
        </div>
        <Link to="/charts" className="block text-center text-xs text-eblue mt-3 hover:underline">View live charts →</Link>
      </div>

      {live.length > 0 && (
        <div className="surface rounded-2xl p-4">
          <div className="flex items-center gap-2 mb-3"><Radio size={16} className="text-destructive live-dot" /><h3 className="font-display font-semibold text-sm">Live Now</h3></div>
          <div className="space-y-3">
            {live.map((ls) => (
              <Link key={ls.id} to={`/live/${ls.id}`} className="flex items-center gap-3 group">
                <div className="relative"><Avatar src={ls.creator?.avatar_url} name={ls.creator?.display_name} size={34} ring /><span className="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[8px] font-bold bg-destructive px-1 rounded">LIVE</span></div>
                <div className="min-w-0"><div className="text-sm font-medium truncate group-hover:text-eblue">{ls.creator?.display_name}</div><div className="text-xs text-muted-foreground truncate">{ls.title}</div></div>
              </Link>
            ))}
          </div>
        </div>
      )}

      <div className="surface rounded-2xl p-4">
        <div className="flex items-center gap-2 mb-3"><Rocket size={16} className="text-gold" /><h3 className="font-display font-semibold text-sm">Rising Stars</h3></div>
        <div className="space-y-3">
          {rising.map((u) => (
            <Link key={u.id} to={`/${u.username}`} className="flex items-center gap-3 group">
              <Avatar src={u.avatar_url} name={u.display_name} size={34} />
              <div className="min-w-0 flex-1"><div className="text-sm font-medium truncate group-hover:text-eblue"><CreatorName user={u} /></div><div className="text-xs text-muted-foreground">{formatNum(u.follower_count)} followers</div></div>
              <span className="text-xs text-gold font-mono">▲{u.growth}</span>
            </Link>
          ))}
        </div>
      </div>
      <div className="text-[11px] text-muted-foreground/60 px-2 leading-relaxed">
        VirtuStars · An ImJove Tech Platform<br />Your Avatar. Your Career. Your Industry.
      </div>
    </aside>
  );
}
